import { trackAnalyticsEvent } from '@/features/home/api/trackAnalyticsEvent';

export type MixpanelEventName =
  | 'page_view'
  | 'scheduling_started'
  | 'rescheduling_started'
  | 'cancelling_started'
  | 'lastsession_studentchange'
  | 'scheduling_students_selected'
  | 'scheduling_sessiondetails_selected'
  | 'scheduling_date_selected'
  | 'scheduling_complete'
  | 'scheduling_seattaken_adjustdate'
  | 'scheduling_closed'
  | 'rescheduling_date_selected'
  | 'rescheduling_complete'
  | 'rescheduling_closed'
  | 'rescheduling_late_cancel'
  | 'cancelling_complete'
  | 'cancelling_closed'
  | 'cancelling_late_complete'
  | 'cancelling_late_closed'
  | 'sessionhistory_filtered'
  | 'sessionhistory_expanded'
  | 'progresscenter_studentchanged'
  | 'overview_30days_viewed'
  | 'overview_skillsmastered_viewed'
  | 'overview_skillsinprogress_viewed'
  | 'report_download'
  | 'report_copylink'
  | 'report_share'
  | 'contactcenter_clicked'
  | 'changepassword_started'
  | 'paymentchange_started'
  | 'paymentchange_method_selected'
  | 'paymentchange_complete'
  | 'invoice_downloaded'
  | 'enrollment_downloaded'
  | 'notifications_reports_disabled'
  | 'notifications_reports_enabled'
  | 'notifications_invoices_disabled'
  | 'notifications_invoices_enabled'
  | 'notifications_enrollment_disabled'
  | 'notifications_enrollment_enabled'
  | 'notifications_scheduling_disabled'
  | 'notifications_scheduling_enabled'
  | 'PWA_install'
  | 'PWA_instructions'
  | 'notifications_markallread'
  | 'notifications_filtered'
  | 'notifications_opened'
  | 'notifications_directmessage_responded'
  | 'notifications_push_enabled'
  | 'addtocalendar_clicked'
  | 'interactivedemo_clicked';

export const captureAnalyticsEvent = (eventName: MixpanelEventName, properties?: Record<string, unknown>) => {
  return trackAnalyticsEvent({ eventName, properties });
};
